module.exports = "<client-row ng-if=!$ctrl.isEditMode client=$ctrl.client survey-status=$ctrl.surveyStatus on-delete-click=$ctrl.deleteClient()> </client-row> ";


//////////////////
// WEBPACK FOOTER
// ./app/components/client-admin/client/client.html
// module id = 365
// module chunks = 0